import { FC } from 'react';
import { PendingEtfTransactions, PendingFundTransactions } from './components';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFund';

export const PendingTransactions: FC = () => {
  const fundCode = useGetFundCodeFromQuery();

  const { fund } = useFindFundByFundCode(fundCode);

  return fund?.fundType === 'FUND' ? (
    <PendingFundTransactions />
  ) : (
    <PendingEtfTransactions />
  );
};
